import React, { useState } from 'react'
import PDFViewer from 'pdf-viewer-reactjs'
import { getBaseUrl } from "../../../../Services/HttpService"
import 'bulma/css/bulma.css'
import 'bulma-helpers/css/bulma-helpers.min.css'
const ViewOpinionComponent = ({ opinion }) => {

    return (<>
        <div className="mainTopic_box">
            <div className="mainTopic_box_body">


                <div className="Single_topicBox">
                    <div className="mb-3 addWriteComments_box 3">
                        <h5>{opinion.ReportName}</h5>
                        <ul>
                            <li> <span>Published on {opinion.PreparedByDateTime}</span></li>
                            {opinion.ReportType === "FILE" && <li>
                            <a href={`${getBaseUrl()}/pdf/${opinion.ReportContent}`} download="pdf" target="_blank">Download</a>
                                {/* <Link to={`${getBaseUrl()}/pdf/${opinion.ReportContent}`} target="_blank" download>Download</Link> */}
                                </li>}
                        </ul>

                    </div>
                    {opinion.ReportType === "TEXT" ? <div dangerouslySetInnerHTML={{ __html: opinion.ReportContent }} /> :
                        <> <PDFViewer
                            document={{
                                url: `${getBaseUrl()}/pdf/${opinion.ReportContent}`,


                            }}
                        /></>}
                </div></div></div>



    </>)
}
export default ViewOpinionComponent